import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck, MapPin, UserRound, Flower2 } from "lucide-react";
import { FRANCHISE_ITEMS } from "@/lib/constants";

const ICONS = { ShieldCheck, MapPin, UserRound, Flower2 };

export default function Franchise() {
  return (
    <section id="franchise" data-testid="franchise-section" className="relative bg-[#050505] overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[1480px] mx-auto px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-[1fr_1.25fr] gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
        >
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.12] text-[#f7f2e8]">
            Shaping the Future of
            <br />
            <span className="text-[#f7f2e8]">Wellness in India</span>
          </h2>
          <span className="mt-6 block w-14 h-px bg-[#c9a14a]/70" aria-hidden="true" />
          <p className="mt-6 text-[#f7f2e8]/75 text-base leading-relaxed max-w-md">
            India&apos;s premium, protocol-led wellness network.
            <br />
            Company-operated. Science-backed. Future-ready.
          </p>
          <div className="mt-9">
            <Link to="/franchise" data-testid="explore-franchise-button" className="btn-outline-gold">
              Explore Franchise Opportunities
            </Link>
          </div>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4">
          {FRANCHISE_ITEMS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                data-testid={`franchise-item-${i}`}
                className="border border-[#c9a14a]/25 -ml-px -mt-px px-5 py-10 flex flex-col items-center text-center min-h-[280px] hover:bg-[#c9a14a]/5 transition-colors duration-500"
              >
                <span className="w-14 h-14 rounded-full border border-[#c9a14a]/50 flex items-center justify-center text-[#c9a14a] shrink-0">
                  <Icon size={22} strokeWidth={1.3} />
                </span>
                <div className="h-10 mt-6 flex items-start justify-center">
                  <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-[#c9a14a] leading-[1.35]">
                    {item.title}
                  </p>
                </div>
                <span className="block w-6 h-px bg-[#c9a14a]/50 my-4" aria-hidden="true" />
                <p className="text-[12px] text-[#f7f2e8]/80 leading-relaxed max-w-[180px]">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
